<template>
  <div class="commodity-list">
    <div class="returned-title medium" v-if="titleType">
      <span>The following items need to be returned</span>
      <span class="returned-title-icon" v-if="serviceOrderDetail.length>0">
        <i class="el-icon-arrow-down" @click="open" v-if="collapse"></i>
        <i class="el-icon-arrow-up" @click="open" v-if="!collapse"></i>
      </span>
    </div>
    <el-collapse-transition>
      <div v-show="collapse">
      <div class="commodity-list-content" v-for="(item,index) in serviceOrderDetail" :key="index">
        <div class="commodity-list-content-top">
          <div class="commodity-list-img"><img :src="item.serviceOrderDetailSkuVO.skuImg"/></div>
          <div class="commodity-list-text">
            <div class="commodity-text-title medium">{{item.serviceOrderDetailSkuVO.skuName}}</div>
            <div class="commodity-text-type">
              <span>{{item.serviceOrderDetailSkuVO.skuParam}}</span>
              <span class="commodity-text-type-order">{{item.serviceOrderDetailSkuVO.skuCode}}</span>
              <!-- <span class="commodity-text-type-orange">This item is temporarily out of stock.Restock Date: Sep 7,2021</span> -->
            </div>
            <div class="commodity-text-ins">
              <div class="commodity-text-ins-price"><span>Price</span><span>{{item.serviceOrderDetailSkuVO.unitPrice}}</span></div>
              <div class="commodity-text-ins-qty"><span>Qty</span><span>{{item['serviceOrderDetailSkuVO']?item['serviceOrderDetailSkuVO']['num']:0}}</span></div>
              <div class="commodity-text-ins-refundable">
                <span>Refundable Refund Qty</span>
                <span>{{item.refundableRetundQty}}</span>
              </div>
              <div class="commodity-text-ins-return">
                <span>Return Qty</span>
                <span>{{item.returnQty}}</span>
                </div>
            </div>
          </div>
        </div>
        <div class="commodity-list-content-description" v-if="item.refundDesc">
          <div class="commodity-description-title">Refund description {{item.refundDesc}}</div>
        </div>
        <div class="commodity-list-content-swiper">
          <div class="commodity-swiper-title">
            <span>Upload picture certificate</span>
            <span class="commodity-swiper-up-limit" v-if="edit">Up to 10 images</span>
          </div>
          <div class="commodity-swiper">
            <img-swiper :edit="edit" :imgListMessage="getImgList(item.serviceOrderFeedbackPicList)"></img-swiper>
          </div>
        </div>
      </div>
    </div>
    </el-collapse-transition>
  </div>
</template>

<script>
// 内容list组件
import imgSwiper from './img-swiper.vue'
export default {
  components: {imgSwiper},
  props: {
    // 两种类型 一种有头部标题 没有上传十张的标题
    titleType: {
      default: true,
      type: Boolean
    },
    edit: {
      default: true,
      type: Boolean
    },
    serviceOrderDetail: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  created() {

  },
  data() {
    return {
      collapse: true,
      imgListMessage: []
    }
  },
  methods: {
    getImgList(imgObjectList) {
      let imgList = []
      imgObjectList.forEach(element => {
        imgList.push(element.img)
      })
      return imgList
    },
    open() {
      this.collapse = !this.collapse
    }
  }
}
</script>

<style lang="less" scoped>
.commodity-list-content-description-text{
  padding: 20px 0 10px 0;
}
@media screen and (max-width: 1024px) {
  .commodity-list{
    padding: 10px !important;
  }
  .commodity-list-img{
    width: 90px !important;
    height: 90px !important;
  }
  .commodity-text-type-orange,.commodity-text-ins-return{
    display: none ;
  }
  .commodity-list-content-description{
    flex-wrap: wrap;
  }
  .commodity-swiper-title{
    width: 100% !important;
    padding-bottom: 13px;
    span{
      display: inline !important;
    }
  }
  .commodity-list-content-swiper{
    flex-wrap: wrap;
  }
  .commodity-swiper{
    width: 100%;
  }
  .m-commodity-text-type-orange,.m-commodity-text-ins-return{
      display: block !important;
    }
  .commodity-list-text{
    width: 70%;
    padding-left: 8px !important;
  }
    .commodity-text-ins{
      flex-wrap: wrap;
    }
  .m-commodity-text-ins-return{
      display: flex !important;
      align-items: center;
      padding-top: 5px;
      span:nth-child(1){
        padding-right: 10px;
      }
    }
}



.returned-title{
  padding-bottom: 20px;
}
.m-commodity-text-type-orange{
  display: none;
  color:#FF4812;
}
.m-commodity-text-ins-return{
  display: none;
}
.commodity-list{
  padding: 18px 20px 0 18px;
  .commodity-list-content{
    padding: 18px 0;
    border-bottom: 1px solid #E1E1E1;
    .commodity-list-content-top{
      display: flex;
    }
    .commodity-list-img{
      width: 120px;
      height: 120px;
      background: #F6F5F3;
      img{
        width: 100%;
        height: 100%;
      }
    }
    .commodity-list-text{
      width: calc(100% - 130px);
      padding-left: 14px;
      line-height: 32px;
      .commodity-text-type-order{
        color:#8F8F8F
      }
      .commodity-text-type-orange{
        color: #FF4812;
      }
      .commodity-text-ins{
        width: 50%;
        display: flex;
        justify-content: space-between;
        div{
          span{
            display: block;
          }
        }
      }
    }
    .commodity-list-content-description{
      display: flex;
      padding-top: 21px;
      align-items: center;
      .commodity-description-title{
        padding-right: 10px;
      }
      .commodity-description-input{
        width: 1010px;
      }
    }
    .commodity-list-content-swiper{
      display: flex;
      padding-top: 15px;
      .commodity-swiper-title{
        width: 125px;
        span{
          display: block;
        }
        .commodity-swiper-up-limit{
          padding-top: 10px;
          color: #8f8f8f;
        }
      }
    }
  }
}
.medium{
  font-family: Satoshi-medium;
}
.ash{
  color: #8F8F8F;
}
</style>



// WEBPACK FOOTER //
// src/pages/order/service-order/components/commodity-list.vue